import OurBeginnings from '../sections/our-beginnings/OurBeginnings';
import App from '../App';

window.App = App;
window.Section = OurBeginnings;
